import React, { useState } from "react";
import { AlertTriangle } from "lucide-react";

// v18 A3: op de telefoon één smalle regel (tik = hele tekst); desktop ongewijzigd.
export const MasterBanner = ({ tekst }) => {
  const [heel, setHeel] = useState(false);
  return (
    <div data-testid="master-basics-banner" className="bg-amber-400 text-amber-950">
      <button type="button" data-testid="master-basics-toggle" aria-expanded={heel} onClick={() => setHeel((v) => !v)}
        className="w-full max-w-7xl mx-auto px-4 md:px-8 py-1 md:py-2 flex items-center justify-center gap-2 text-center md:cursor-default">
        <AlertTriangle className="h-3.5 w-3.5 md:h-4 md:w-4 shrink-0" strokeWidth={2.4} />
        <p className={`text-[11px] md:text-sm font-bold min-w-0 ${heel ? "" : "truncate md:whitespace-normal md:overflow-visible"}`}>{tekst}</p>
      </button>
    </div>
  );
};
